import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class ClienteService extends BaseService {
  constructor() {
    super(`${ConfigApi.boletoURL}`);
  }

  getFilter() {
    return new Filter();
  }

  async getBoletoPDF(nossoNumero) {
    this.setLoading(true);
    try {
      const response = await this.api.get(`${ConfigApi.boletoPdfURL}/bol_${nossoNumero}.pdf`, {
        responseType: 'blob',
        onDownloadProgress: evt => {
          if (evt.total) {
            const pct = Math.round((evt.loaded * 100) / evt.total);
            // atualize seu estado/UI aqui
            this.setProgress(pct);
            // opcional: velocidade e tempo restante
            // const elapsed = (evt.timeStamp ?? 0) / 1000; // ms -> s (nem sempre útil)
          } else {
            // fallback: progresso indeterminado
            this.setProgress(0);
          }
        },
      });

      return response.data;
    } finally {
      this.setLoading(false);
      this.setProgress(null);
    }
  }
}

class Filter {
  constructor() {
    this.nome = '';
    this.idRevenda = undefined;
    this.numeroContrato = 0;
    this.sacadoCpfCnpj = '';
    this.inativo = 'false';

    this.resumo = '';
    this.limit = 11;
    this.page = 0;
  }
}

export default new ClienteService();
